import styled from "styled-components";
import { Colors } from "../../styles/consts";

export const MainDescriptionDiv = styled.div`
text-align: center;
width: 560px;
display: flex;
flex-wrap:wrap ;
justify-content: center;
align-items: center;

`

export const Description = styled.p`
color: ${Colors.PRIMARY_BLUE};
font-size: 24px;

`

export const ImgFire = styled.img`
width: 300px;
`